import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleActiveTab, toggleActiveChart, setEventsListStartIndex, setSelectedEvent } from '../../store/statsSlice.js';
import Menu from '../../components/menu/menu';
import Content from '../../components/content/content';
import './Stats.css'
import {
    PieChart, Pie, Cell,
    ReferenceLine, Line, LineChart,
    Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";


import UniversalLineWithComponents from '../../components/components/universal_line_with_components/universalLineWithComponents.jsx';
import customText from '../../components/components/custom_text/customText.jsx';

import { ReactComponent as ThreePeople } from '../../components/icons/people.svg';
import { ReactComponent as StatusUp } from '../../components/icons/status-up.svg';
import { ReactComponent as Chart } from '../../components/icons/chart.svg';
import { ReactComponent as Lock } from '../../components/icons/lock.svg';

import CustomTile  from "../../components/components/custom_tile/customTile";
import Column from "../../components/components/column_layout/column.jsx";
import ColumnLayout from "../../components/components/column_layout/columnLayout.jsx";

import ApiService from '../../components/api_services/apiService';
import CustomDropdown from "../../components/components/custom_list/customDropdown";

const InfoModal = ({ isOpen, onClose, title, description }) => {
    if (!isOpen) return null;

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
            }}
            onClick={onClose}
        >
            <div
                style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    padding: '24px',
                    maxWidth: '500px',
                    width: '90%',
                    position: 'relative',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '16px',
                        right: '16px',
                        background: 'none',
                        border: 'none',
                        fontSize: '24px',
                        cursor: 'pointer',
                        color: '#666',
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '50%',
                        transition: 'background-color 0.2s',
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                    ×
                </button>

                <h3 style={{
                    marginTop: 0,
                    marginBottom: '16px',
                    color: '#333',
                    fontSize: '20px',
                    fontWeight: 'bold',
                }}>
                    {title}
                </h3>

                <p style={{
                    margin: 0,
                    color: '#666',
                    lineHeight: '1.6',
                    fontSize: '15px',
                }}>
                    {description}
                </p>
            </div>
        </div>
    );
};

// Komponent InfoIcon - mała ikonka "i" w kółeczku
const InfoIcon = ({ onClick }) => {
    return (
        <button
            onClick={onClick}
            style={{
                width: '20px',
                minWidth: '20px',
                height: '20px',
                minHeight: '20px',
                borderRadius: '50%',
                border: '2px solid #EE8F3B',
                backgroundColor: 'white',
                color: '#EE8F3B',
                fontSize: '12px',
                fontWeight: 'bold',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'all 0.2s',
                padding: 0,
                verticalAlign: 'middle',
                marginLeft: 'auto'
            }}
            onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#EE8F3B';
                e.target.style.color = 'white';
            }}
            onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'white';
                e.target.style.color = '#EE8F3B';
            }}
        >
            i
        </button>
    );
};

function Stats() {
    const dispatch = useDispatch();
    const activeTab = useSelector((state) => state.stats.activeTab);
    const activeChart = useSelector((state) => state.stats.activeChart);
    const eventsListStartIndex = useSelector((state) => state.stats.eventsListStartIndex);
    const selectedEventId = useSelector((state) => state.stats.selectedEventId);

    const [dropdown1Value, setDropdown1Value] = useState('0');
    const [dropdown2Value, setDropdown2Value] = useState('LAST_7_DAYS');
    const [dropdown3Value, setDropdown3Value] = useState('0');

    const [showViewsModal, setShowViewsModal] = useState(false);
    const [showUsersModal, setShowUsersModal] = useState(false);
    const [showUsers2Modal, setShowUsers2Modal] = useState(false);

    const [showRank1Modal, setShowRank1Modal] = useState(false);
    const [showRank2Modal, setShowRank2Modal] = useState(false);
    const [isRankEventModalOpen, setIsRankEventModalOpen] = useState(false);
    const [rankEventModalData, setRankEventModalData] = useState(null);
    const [activeTopRanking, setActiveTopRanking] = useState('interest');

    const formatForJava = (date) => {
        const pad = (n) => (n < 10 ? '0' + n : n);

        const yyyy = date.getFullYear();
        const mm = pad(date.getMonth() + 1);
        const dd = pad(date.getDate());
        const hh = pad(date.getHours());
        const min = pad(date.getMinutes());
        const ss = pad(date.getSeconds());

        return `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}`;
    };
    const formatEventDate = (value) => {
        if (!value) return '';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
            return value;
        }

        // Formatujemy samą datę
        const datePart = date.toLocaleDateString('pl-PL', {
            weekday: 'short',
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        });

        // Formatujemy samą godzinę (numeric usuwa zero z przodu)
        let timePart = date.toLocaleTimeString('pl-PL', {
            hour: 'numeric',
            minute: '2-digit'
        });

        // Dodatkowe zabezpieczenie na wypadek, gdyby system i tak dodał zero (np. "09:15")
        timePart = timePart.startsWith('0') ? timePart.substring(1) : timePart;

        // Łączymy znakiem nowej linii
        return `${datePart}`;
    };

    const formatEventTime = (value) => {
        if (!value) return '';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
            return '';
        }
        let timePart = date.toLocaleTimeString('pl-PL', { hour: 'numeric', minute: '2-digit' });
        timePart = timePart.startsWith('0') ? timePart.substring(1) : timePart;
        return `${timePart}`;
    };

    const [data1, setData1] = useState([]);
    const [data1Female, setData1Female] = useState([]);
    const [data1Male, setData1Male] = useState([]);
    const [data1Other, setData1Other] = useState([]);

    const VISIBLE_BARS_COUNT = 7; // Ile dni widzimy naraz
    const [barStartIndex, setBarStartIndex] = useState(0);

    const now = new Date();
    const sevenDaysBefore = new Date();
    sevenDaysBefore.setDate(now.getDate() - 7);

    const startDateTemp = now.getDate - VISIBLE_BARS_COUNT;
    const [endDate, setEndDate] = useState(now);
    const [startDate, setStartDate] = useState(sevenDaysBefore);

    const handleBarPrev = () => {
        // 1. Tworzymy nowe kopie obiektów na podstawie aktualnego stanu
        const newStart = new Date(startDate);
        const newEnd = new Date(endDate);

        // 2. Odejmujemy jeden dzień
        newStart.setDate(newStart.getDate() - 1);
        newEnd.setDate(newEnd.getDate() - 1);

        // 3. Aktualizujemy stan
        setStartDate(newStart);
        setEndDate(newEnd);

        // 4. Logowanie (używamy zmiennych lokalnych, bo stan jeszcze się nie zmienił)
        console.log("New Start date:", newStart, "New End date:", newEnd);
    };

    const handleBarNext = () => {
        const newStart = new Date(startDate);
        const newEnd = new Date(endDate);

        newStart.setDate(newStart.getDate() + 1);
        newEnd.setDate(newEnd.getDate() + 1);

        setStartDate(newStart);
        setEndDate(newEnd);
        console.log("New Start:", newStart, "New End:", newEnd);
    };

    const handleBarPrev7 = () => {
        const newStart = new Date(startDate);
        const newEnd = new Date(endDate);

        newStart.setDate(newStart.getDate() - 7);
        newEnd.setDate(newEnd.getDate() - 7);

        setStartDate(newStart);
        setEndDate(newEnd);
        console.log("New Start:", newStart, "New End:", newEnd);
    };

    const handleBarNext7 = () => {
        const newStart = new Date(startDate);
        const newEnd = new Date(endDate);

        newStart.setDate(newStart.getDate() + 7);
        newEnd.setDate(newEnd.getDate() + 7);

        setStartDate(newStart);
        setEndDate(newEnd);
        console.log("New Start:", newStart, "New End:", newEnd);
    };

    const [visibleDataSource, setVisibleDataSource] = useState({
        All: true,
        Female: false,
        Male: false,
        Other: false,
    });

    const selectDataSource = (key) => {
        setVisibleDataSource((prev) => {
            if (prev[key]) return prev;
            return {
                All: false,
                Female: false,
                Male: false,
                Other: false,
                [key]: true,
            };
        });
    };

    const activeData1 = visibleDataSource.Male
        ? data1Male
        : visibleDataSource.Other
            ? data1Other
            : visibleDataSource.Female
                ? data1Female
                : data1;

    const visibleData1 = activeData1.slice(barStartIndex, barStartIndex + VISIBLE_BARS_COUNT);


    // Checkboxy sterujące słupkami (co ma się wyświetlać na wykresie)
    const [visibleBars, setVisibleBars] = useState({
        Przeglad: true,
        Paczka: true,
        Ulubione: true,
    });
    const [visibleBarsDemography, setVisibleBarsDemography] = useState({
        all: true,
        female: false,
        male: false,
        other: false,
    });

    const toggleBar = (key) => {
        setVisibleBars((prev) => {
            const enabledCount = Object.values(prev).filter(Boolean).length;
            const isCurrentlyEnabled = prev[key];

            // Nie pozwól odznaczyć ostatniego zaznaczonego checkboxa
            if (isCurrentlyEnabled && enabledCount === 1) return prev;

            return { ...prev, [key]: !prev[key] };
        });
    };

    const toggleBarDemography = (key) => {
        setVisibleBarsDemography((prev) => {
            if (prev[key]) return prev;

            return {
                all: false,
                female: false,
                male: false,
                other: false,
                [key]: true,
            };
        });
    };


    const data2 = [
        { dzien: '1-07', Przeglad: 10 },
        { dzien: '2-07', Przeglad: 25 },
        { dzien: '3-07', Przeglad: 20 },
        { dzien: '4-07', Przeglad: 5 },
        { dzien: '5-07', Przeglad: 70 },
        { dzien: '6-07', Przeglad: 55 },
        { dzien: '7-07', Przeglad: 25 },
    ];

    const dataXXX = [
        { key: '18-24', all: 10, male: 10, female: 0, other: 0 },
        { key: '25-29', all: 35, male: 25, female: 10, other: 0  },
        { key: '30-39', all: 33, male: 20, female: 11, other: 2  },
        { key: '40-49', all: 25, male: 5, female: 20, other: 0  },
        { key: '50+', all: 78, male: 70, female: 3, other: 5  },
    ];

    // const [showUsers2Modal, setShowUsers2Modal] = useState(false);

    const [pieData, setPieData] = useState([
        { name: 'Kobiety', value: 0, percentage: 0 },
        { name: 'Mężczyźni', value: 0, percentage: 0 },
        { name: 'Inna', value: 0, percentage: 0 },
    ]);

    const [pieData2, setPieData2] = useState ([
        { name: 'Kobiety', value: 0, percentage: 0 },
        { name: 'Mężczyźni', value: 0, percentage: 0 },
        { name: 'Inna', value: 0, percentage: 0 },
    ]);

    const [pieData3, setPieData3] = useState ([
        { name: 'Nowi', value: 0, percentage: 0 },
        { name: 'Powracający', value: 0, percentage: 0 },
    ]);
    const dataInsidePie = "156";

    const PIE_COLORS = ['#EE8F3B', '#7D959F', '#0aa2d5'];

    const [data4, setData4] = useState([
        { name: 'Twoje wydarzenie miało o {1} większe zainteresowanie (mierzone liczbą osób tworzących paczki i dołączających do nich) niż średnia w tej kategorii.', value: '' },
        { name: 'Współczynnik konwersji. {2} osób odwiedziło stronę Twojego wydarzenia, z czego {3} zdecydowały się dołączyć.', value: '' },
    ]);

    const calculateSum = (data) => {
        return data.reduce((acc, item) => acc + (item.value || 0), 0);
    };

    const [eventsDataForTiles, setEventsDataForTiles] = useState([]);
    const [topEventsByInterest, setTopEventsByInterest] = useState([]);
    const [topEventsByPackages, setTopEventsByPackages] = useState([]);

    const handleSidebarClick = (tabName) => {
        dispatch(toggleActiveTab(tabName));
    };

    useEffect(() => {
        dispatch(setEventsListStartIndex(0));
    }, [eventsDataForTiles.length, dispatch]);

    useEffect(() => {
        fetchBothTopEvents();
    }, [dropdown1Value, dropdown2Value]);

    // const visibleEvents = eventsDataForTiles.slice(eventsListStartIndex, eventsListStartIndex + 5);
    const visibleEvents = eventsDataForTiles.slice(0 , eventsDataForTiles.length);
    const canScrollUp = eventsListStartIndex > 0;
    const canScrollDown = eventsListStartIndex + 5 < eventsDataForTiles.length;
    const showNavigationButtons = false; //eventsDataForTiles.length > 5;

    const handleEventClick = (eventId) => {
        dispatch(setSelectedEvent(eventId));
    };

    const openRankEventModal = (event) => {
        dispatch(setSelectedEvent(event.id));
        setRankEventModalData(event);
        setIsRankEventModalOpen(true);
    };

    const closeRankEventModal = () => {
        setIsRankEventModalOpen(false);
        setRankEventModalData(null);
    };

    useEffect(() => {
        if (selectedEventId) {
            setDropdown3Value(selectedEventId.toString());
        } else {
            setDropdown3Value('0');
        }

    }, [selectedEventId]);

    const handleDropdown3Change = (e) => {
        const newValue = e.target.value;
        setDropdown3Value(newValue);

        // Jeśli wybrano '0' (Wszystkie), a mamy zaznaczony event - odznaczamy go.
        // Jeśli wybrano konkretne ID - aktualizujemy Redux.
        if (newValue === '0') {
            if (selectedEventId !== 0) {
                dispatch(setSelectedEvent(0));
            }
        } else {
            const numericId = parseInt(newValue, 10);
            if (selectedEventId !== numericId) {
                dispatch(setSelectedEvent(numericId));
            }
        }
    };

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const ensureTokensValid = async () => {
        const tokensValid = await ApiService.checkTokenExpiration();
        return !!tokensValid;
    };

    const fetchStatistics = async () => {
        const tokensValid = await ensureTokensValid();
        if (!tokensValid) {
            return;
        }
        if (selectedEventId === null) {
            return;
        }
        const eventId =  selectedEventId;
        setLoading(true);
        try {
            const response = await ApiService.getPieStatisticsViews(eventId);
            console.log('Statistics Part 1: ', response)
            setPieData( [
                {
                    name: 'Kobiety',
                    value: response.data.totalViewsBySex.FEMALE,
                    percentage: response.data.totalViewsBySexPercentage.FEMALE
                },
                {
                    name: 'Mężczyźni',
                    value: response.data.totalViewsBySex.MALE,
                    percentage: response.data.totalViewsBySexPercentage.MALE
                },
                {
                    name: 'Inna',
                    value: response.data.totalViewsBySex.OTHER,
                    percentage: response.data.totalViewsBySexPercentage.OTHER
                },
            ]);
        } catch (error) {
            setError(error);
        }

        try {
            const response = await ApiService.getPieStatisticsBunches(eventId);
            console.log('Statistics Part 2: ', response)
            setPieData2([
                {
                    name: 'Kobiety',
                    value: response.data.numberOfParticipantsBySex.FEMALE,
                    percentage: response.data.numberOfParticipantsBySexPercentage.FEMALE
                },
                {
                    name: 'Mężczyźni',
                    value: response.data.numberOfParticipantsBySex.MALE,
                    percentage: response.data.numberOfParticipantsBySexPercentage.MALE
                },
                {
                    name: 'Inna',
                    value: response.data.numberOfParticipantsBySex.OTHER,
                    percentage: response.data.numberOfParticipantsBySexPercentage.OTHER
                },
            ]);
        } catch (error) {
            setError(error);
        }

        try {
            const response = await ApiService.getPieStatisticsUsers(eventId);

            console.log('Statistics Part 3: ', response);
            setPieData3([
                {
                    name: 'Nowi',
                    value: response.data.newParticipants,
                    percentage: response.data.newParticipantsPercentage },
                {
                    name: 'Powracający',
                    value: response.data.oldParticipants,
                    percentage: response.data.oldParticipantsPercentage },
            ]);
        } catch (error) {
            setError(error);
        }

        if ( selectedEventId !== 0) {
            try {
                const response = await ApiService.getComparisonStatistics(eventId);
                console.log('Statistics Part 4: ', response)

                let x;
                let txt;
                let basicTxt;
                if (response.data.comparisonEventWithCategory <0) {
                    txt = ' niższa ';
                    x = - response.data.comparisonEventWithCategory;
                    basicTxt = `Liczba osób dołączających do paczek przy tym wydarzeniu jest obecnie o ${x}%${txt} od średniej w tej kategorii.`;
                } else {
                    txt = ' większe ';
                    x = response.data.comparisonEventWithCategory;
                    basicTxt = `Twoje wydarzenie miało o ${x}%${txt} zainteresowanie (mierzone liczbą osób tworzących paczki i dołączających do nich) niż średnia w tej kategorii.`;
                }

                setData4([
                    { name: basicTxt , value: `${x}%${txt}` },
                    { name: `Współczynnik konwersji. ${response.data.numberOfViews} otworzyło Twoje wydarzenie, a ${response.data.eventBunchesParticipantsCount} zdecydowały się dołączyć (tworząc lub dołączając do paczki)`, value: `${response.data.conversionRate}%` },
                ])
            } catch (error) {
                setError(error);
            }
        }


        try {
            const from = formatForJava(startDate);
            const to = formatForJava(endDate);

            const response = await ApiService.getChartOneStatistics(from, to, eventId);
            console.log('Statistics Part 5: ', response);

            // 1. Pobieramy obiekt mapy z response.data
            const rawData = response.data;

            // 2. Przekształcamy mapę na tablicę obiektów pasującą do Twojej struktury
            const mappedData = Object.entries(rawData)
                .map(([dateKey, values]) => ({
                    // Skracamy format "18-01-26" do "18-01" dla lepszej czytelności na wykresie
                    dzien: dateKey || 0,
                    Przeglad: values.views || 0,
                    Paczka: values.bunches || 0,
                    Ulubione: values.favorites || 0
                }))
                .sort((a, b) => {
                    // Sortowanie, aby daty na wykresie szły po kolei
                    const parseDate = (d) => {
                        const [day, month] = d.split('-').map(Number);
                        return month * 100 + day; // Proste porównanie miesiąc + dzień
                    };
                    return parseDate(a.dzien) - parseDate(b.dzien);
                });

            // 3. Zapisujemy gotową tablicę do stanu
            setData1(mappedData);

        } catch (error) {
            setError(error);
        }

    //     stats by sex

        try {
            const from = formatForJava(startDate);
            const to = formatForJava(endDate);

            const response = await ApiService.getChartOneStatisticsBySex(from, to, eventId, 'FEMALE');
            console.log('Statistics Part 5: ', response);

            // 1. Pobieramy obiekt mapy z response.data
            const rawData = response.data;

            // 2. Przekształcamy mapę na tablicę obiektów pasującą do Twojej struktury
            const mappedData = Object.entries(rawData)
                .map(([dateKey, values]) => ({
                    // Skracamy format "18-01-26" do "18-01" dla lepszej czytelności na wykresie
                    dzien: dateKey || 0,
                    Przeglad: values.views || 0,
                    Paczka: values.bunches || 0,
                    Ulubione: values.favorites || 0
                }))
                .sort((a, b) => {
                    // Sortowanie, aby daty na wykresie szły po kolei
                    const parseDate = (d) => {
                        const [day, month] = d.split('-').map(Number);
                        return month * 100 + day; // Proste porównanie miesiąc + dzień
                    };
                    return parseDate(a.dzien) - parseDate(b.dzien);
                });

            // 3. Zapisujemy gotową tablicę do stanu
            setData1Female(mappedData);

        } catch (error) {
            setError(error);
        }


        try {
            const from = formatForJava(startDate);
            const to = formatForJava(endDate);

            const response = await ApiService.getChartOneStatisticsBySex(from, to, eventId, 'MALE');
            console.log('Statistics Part 5: ', response);

            // 1. Pobieramy obiekt mapy z response.data
            const rawData = response.data;

            // 2. Przekształcamy mapę na tablicę obiektów pasującą do Twojej struktury
            const mappedData = Object.entries(rawData)
                .map(([dateKey, values]) => ({
                    // Skracamy format "18-01-26" do "18-01" dla lepszej czytelności na wykresie
                    dzien: dateKey || 0,
                    Przeglad: values.views || 0,
                    Paczka: values.bunches || 0,
                    Ulubione: values.favorites || 0
                }))
                .sort((a, b) => {
                    // Sortowanie, aby daty na wykresie szły po kolei
                    const parseDate = (d) => {
                        const [day, month] = d.split('-').map(Number);
                        return month * 100 + day; // Proste porównanie miesiąc + dzień
                    };
                    return parseDate(a.dzien) - parseDate(b.dzien);
                });

            // 3. Zapisujemy gotową tablicę do stanu
            setData1Male(mappedData);

        } catch (error) {
            setError(error);
        }


        try {
            const from = formatForJava(startDate);
            const to = formatForJava(endDate);

            const response = await ApiService.getChartOneStatisticsBySex(from, to, eventId, 'OTHER');
            console.log('Statistics Part 5: ', response);

            // 1. Pobieramy obiekt mapy z response.data
            const rawData = response.data;

            // 2. Przekształcamy mapę na tablicę obiektów pasującą do Twojej struktury
            const mappedData = Object.entries(rawData)
                .map(([dateKey, values]) => ({
                    // Skracamy format "18-01-26" do "18-01" dla lepszej czytelności na wykresie
                    dzien: dateKey || 0,
                    Przeglad: values.views || 0,
                    Paczka: values.bunches || 0,
                    Ulubione: values.favorites || 0
                }))
                .sort((a, b) => {
                    // Sortowanie, aby daty na wykresie szły po kolei
                    const parseDate = (d) => {
                        const [day, month] = d.split('-').map(Number);
                        return month * 100 + day; // Proste porównanie miesiąc + dzień
                    };
                    return parseDate(a.dzien) - parseDate(b.dzien);
                });

            // 3. Zapisujemy gotową tablicę do stanu
            setData1Other(mappedData);

        } catch (error) {
            setError(error);
        }


    }

    const fetchBothTopEvents = async () => {
        const tokensValid = await ensureTokensValid();
        if (!tokensValid) {
            return;
        }

        const path1 = dropdown2Value + '/' + dropdown1Value + '/INTEREST' ;
        const response1 = await ApiService.getEventsTopCharts(path1);
        //----------------------------
        // Przykładowe dane dla Top 10 wg zainteresowania
        // W przyszłości tutaj będzie prawdopodobnie osobne API call
        const mockTopByInterest = response1.data.map((event, index) => ({
            ...event,
            rank: index + 1
        }));
        setTopEventsByInterest(mockTopByInterest);

        const path2 = dropdown2Value + '/' + dropdown1Value + '/BUNCHES' ;
        const response2 = await ApiService.getEventsTopCharts(path2);

        // Przykładowe dane dla Top 10 wg paczek
        // W przyszłości tutaj będzie prawdopodobnie osobne API call
        const mockTopByPackages = response2.data.map((event, index) => ({
            ...event,
            rank: index + 1
        }));
        setTopEventsByPackages(mockTopByPackages);
        //----------------------------
    }
    const [dropdown3Options, setDropdown3Options] = useState([{ id: 0, name: 'wszystkie', nameEng: 'all' }])

    const fetchEvents = async () => {
        const tokensValid = await ensureTokensValid();
        if (!tokensValid) {
            return;
        }
        setLoading(true);
        setError(null);

        try {
            const response = await ApiService.getEvents2();
            console.log('Pobrane eventy:', response.data);

            // Zapisz dane w state
            setEventsDataForTiles(response.data);

            const options = response.data.map(event => ({
                id: event.id,
                name: event.name
            }));
            setDropdown3Options([{ id: 0, name: 'wszystkie', nameEng: 'all' }, ...options]);


            await fetchBothTopEvents();

        } catch (err) {
            console.error('Błąd pobierania eventów:', err);
            setError(err.message || 'Nie udało się pobrać eventów');
        } finally {
            setLoading(false);
        }
    };

    const [dropdown1Options, setDropdown1Options] = useState([{ id: 0, name: 'wszystkie', nameEng: 'all' }])

    const fetchEventsCategories = async () => {
        const tokensValid = await ensureTokensValid();
        if (!tokensValid) {
            return;
        }
        setLoading(true);
        setError(null);
        try {

            const response = await ApiService.getEventsCategories()
            console.log('Pobrane kategorie:', response.data);
            setDropdown1Options([...dropdown1Options, ...response.data]);
            console.log('Aktualne opcje:', dropdown1Options);

        } catch (err) {
            console.error('Błąd pobierania kategorii:', err);
            setError(err.message || 'Nie udało się pobrać kategorii eventów');
        } finally {
            setLoading(false);
        }
    };
    // Funkcja pomocnicza dla czytelności
    const isFutureOrToday = (dateToCheck) => {
        const d = new Date(dateToCheck);
        const today = new Date();
        // Zerujemy godziny, jeśli chcemy porównywać tylko dni
        today.setHours(23, 59, 59, 999);
        return d >= today;
    };

    // Opcjonalnie: automatyczne pobieranie przy montowaniu komponentu
    useEffect(() => {
        fetchEvents();
        fetchEventsCategories();

        fetchStatistics();
    }, []);

    // Opcjonalnie: automatyczne pobieranie przy montowaniu komponentu
    useEffect(() => {
        fetchEvents();
        fetchEventsCategories();
        fetchStatistics();
    }, [selectedEventId, startDate]);


    // Nowy ref dla kontenera z eventami
    const eventsScrollRef = useRef(null);

    // Funkcje do przewijania
    const scrollUp = () => {
        if (canScrollUp) {
            dispatch(setEventsListStartIndex(eventsListStartIndex - 1));
        }
    };

    const scrollDown = () => {
        if (canScrollDown) {
            dispatch(setEventsListStartIndex(eventsListStartIndex + 1));
        }
    };

    return (
    <div>
      <Menu />
      <Content>
        <div className="stats-container">
          <div className="stats-header">
            <h1>Statystyki</h1>
          </div>

          <div className="stats-content">
              <div className="stats-sidebar">
                  <div
                      className={`sidebar-item ${activeTab === 'Ogólne' ? 'active' : ''}`}
                      onClick={() => handleSidebarClick('Ogólne')}
                  >
                      Ogólne statystyki<span className="right-oriented-stats">&#10217;</span>
                  </div>
                  <div
                      className={`sidebar-item ${activeTab === 'Rankingi' ? 'active' : ''}`}
                      onClick={() => handleSidebarClick('Rankingi')}
                  >
                      Rankingi wydarzeń<span className="right-oriented-stats">&#10217;</span>
                  </div>

                  {activeTab != 'Rankingi' && <div className="sidebar-after-item">
                      Wydarzenia

                      {showNavigationButtons && (
                          <button
                              onClick={scrollUp}
                              disabled={!canScrollUp}
                              style={{
                                  display: 'block',
                                  width: '106%',
                                  padding: '8px',
                                  marginTop: '20px',
                                  backgroundColor: canScrollUp ? '#EE8F3B' : '#ccc',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '4px',
                                  cursor: canScrollUp ? 'pointer' : 'not-allowed',
                                  fontSize: '16px',
                                  fontWeight: 'bold'
                              }}
                          >
                              ▲ Góra
                          </button>
                      )}

                      { !loading && ( visibleEvents.map((event, index) => (
                              <div
                                  key={event.id || index}
                                  style={{ marginBottom: '-45px', minWidth: '460px', maxWidth: '500px', marginTop: '17px', transform: 'scale(0.65)', transformOrigin: 'left top'  }}
                                  onClick={() => handleEventClick(event.id)}
                              >
                                  <CustomTile
                                      imageUrl={`/api/events-images/${event.image_hash_code}`}
                                      textLines={[
                                          event.name,
                                          event.place + ',' + event.city,
                                          formatEventDate(event.startDate),
                                          formatEventTime(event.startDate)]}

                                      backgroundColor={selectedEventId === event.id ? "#fff5e6" : "#F4F4F4"}
                                      showNumber={false}
                                      useAuth={true}
                                  />
                              </div>
                          ))
                      )}

                      {showNavigationButtons && (
                          <button
                              onClick={scrollDown}
                              disabled={!canScrollDown}
                              style={{
                                  display: 'block',
                                  width: '106%',
                                  padding: '8px',
                                  marginTop: '28px',
                                  backgroundColor: canScrollDown ? '#EE8F3B' : '#ccc',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '4px',
                                  cursor: canScrollDown ? 'pointer' : 'not-allowed',
                                  fontSize: '16px',
                                  fontWeight: 'bold'
                              }}
                          >
                              ▼ Dół
                          </button>
                      )}

                  </div>}
              </div>

              {/********************************/}
              {/*    zakładka ogólne początek  */}

              {activeTab === 'Ogólne' && <div className="stats-main">
                  <div className={"line-right-aligned"}>
                      <div className="line-label">Lista wydarzeń: </div>
                      <CustomDropdown
                          placeholder="Wybierz opcję..."
                          options={dropdown3Options.map((opt, index) => ({
                              value: opt.id.toString(),
                              label: opt.name
                          }))}
                          value={dropdown3Value}
                          onChange={handleDropdown3Change}
                          hoverClass="hover-active"
                          activeClass="is-active"
                      />
                  </div>

                  <div className="grid-chart">
                      <div className="chart-with-frame flex-line-item">
                          <div className='header-line'><ThreePeople className='orange'/>Wyświetlenia <InfoIcon onClick={() => setShowViewsModal(true)} /></div>

                          <div className="stats-pie-container">
                              {/* Wykres */}
                              <div className="stats-pie-wrapper">
                                  <ResponsiveContainer width="100%" height="100%">
                                      <PieChart>
                                          <Pie
                                              data={pieData}
                                              cx="50%"                  // Teraz może być wyśrodkowany
                                              cy="50%"
                                              innerRadius={60}
                                              outerRadius={100}
                                              fill="#8884d8"
                                              dataKey="value"
                                              paddingAngle={3}
                                              labelLine={false}
                                          >
                                              {pieData.map((entry, index) => (
                                                  <Cell
                                                      key={`cell-${index}`}
                                                      fill={PIE_COLORS[index % PIE_COLORS.length]}
                                                  />
                                              ))}
                                          </Pie>
                                      </PieChart>
                                  </ResponsiveContainer>

                                  {/* Tekst w środku */}
                                  <div className="stats-pie-center-label">
                                      <div className="stats-pie-center-text">
                                          {calculateSum(pieData)}
                                      </div>
                                  </div>
                              </div>

                              {/* Własna legenda obok/pod wykresem */}
                              <div className="stats-pie-legend">
                                  {pieData.map((entry, index) => (
                                      <div key={index} className="stats-pie-legend-item">
                                          <div
                                              className="stats-pie-legend-dot"
                                              style={{backgroundColor: PIE_COLORS[index]}}
                                          />
                                          <span className="stats-pie-legend-text">
                                                  {entry.name}<br/>{entry.value} - {entry.percentage}%
                                              </span>
                                      </div>
                                  ))}
                              </div>
                          </div>

                      </div>
                      <div className="chart-with-frame flex-line-item">
                          <div className='header-line'><ThreePeople className='orange'/>Uczestnicy paczek<InfoIcon onClick={() => setShowUsersModal(true)} /></div>

                          <div className="stats-pie-container">
                              {/* Wykres */}
                              <div className="stats-pie-wrapper">
                                  <ResponsiveContainer width="100%" height="100%">
                                      <PieChart>
                                          <Pie
                                              data={pieData2}
                                              cx="50%"                  // Teraz może być wyśrodkowany
                                              cy="50%"
                                              innerRadius={60}
                                              outerRadius={100}
                                              fill="#8884d8"
                                              dataKey="value"
                                              paddingAngle={3}
                                              labelLine={false}
                                          >
                                              {pieData2.map((entry, index) => (
                                                  <Cell
                                                      key={`cell-${index}`}
                                                      fill={PIE_COLORS[index % PIE_COLORS.length]}
                                                  />
                                              ))}
                                          </Pie>
                                      </PieChart>
                                  </ResponsiveContainer>

                                  {/* Tekst w środku */}
                                  <div className="stats-pie-center-label">
                                      <div className="stats-pie-center-text">
                                          {calculateSum(pieData2)}
                                      </div>
                                  </div>
                              </div>

                              {/* Własna legenda obok/pod wykresem */}
                              <div className="stats-pie-legend">
                                  {pieData2.map((entry, index) => (
                                      <div key={index} className="stats-pie-legend-item">
                                          <div
                                              className="stats-pie-legend-dot"
                                              style={{backgroundColor: PIE_COLORS[index]}}
                                          />
                                          <span className="stats-pie-legend-text">
                                                  {entry.name}<br/>{entry.value} - {entry.percentage}%
                                              </span>
                                      </div>
                                  ))}
                              </div>
                          </div>

                      </div>


                      <div className="chart-with-frame flex-line-item">
                          <div className='header-line'><ThreePeople className='orange'/>Użytkownicy: nowi vs powracający<InfoIcon onClick={() => setShowUsers2Modal(true)} /></div>

                          <div className="stats-pie-container">
                              {/* Wykres */}
                              <div className="stats-pie-wrapper">
                                  <ResponsiveContainer width="100%" height="100%">
                                      <PieChart>
                                          <Pie
                                              data={pieData3}
                                              cx="50%"                  // Teraz może być wyśrodkowany
                                              cy="50%"
                                              innerRadius={60}
                                              outerRadius={100}
                                              fill="#8884d8"
                                              dataKey="value"
                                              paddingAngle={3}
                                              labelLine={false}
                                          >
                                              {pieData3.map((entry, index) => (
                                                  <Cell
                                                      key={`cell-${index}`}
                                                      fill={PIE_COLORS[index % PIE_COLORS.length]}
                                                  />
                                              ))}
                                          </Pie>
                                      </PieChart>
                                  </ResponsiveContainer>

                                  {/* Tekst w środku */}
                                  <div className="stats-pie-center-label">
                                      <div className="stats-pie-center-text">
                                          {calculateSum(pieData3)}
                                      </div>
                                  </div>
                              </div>

                              {/* Własna legenda obok/pod wykresem */}
                              <div className="stats-pie-legend">
                                  {pieData3.map((entry, index) => (
                                      <div key={index} className="stats-pie-legend-item">
                                          <div
                                              className="stats-pie-legend-dot"
                                              style={{backgroundColor: PIE_COLORS[index]}}
                                          />
                                          <span className="stats-pie-legend-text">
                                                  {entry.name}<br/>{entry.value} - {entry.percentage}%
                                              </span>
                                      </div>
                                  ))}
                              </div>
                          </div>

                      </div>


                      {/*{ !(dropdown3Value === '0') && (*/}
                          <div className="chart-with-frame-orange flex-line-item last-grow"
                               style={{
                                   visibility: dropdown3Value === '0' ? 'hidden' : 'visible',
                                   height: dropdown3Value === '0' ? '0px' : 'auto',
                                   padding: dropdown3Value === '0' ?  '0px' : '20px'}}
                          >
                              <div className='header-line'>
                                  <StatusUp className='orange' />
                                  Podsumowanie
                              </div>

                              <div className="summary-horizontal-container">
                                  {data4.map((entry, index) => (
                                      <div key={index} className='summary-card'>
                                          <div className='text'>{entry.name}</div>
                                          <div className='text-rounded-rectangle-2'>{entry.value}</div>
                                      </div>
                                  ))}
                              </div>
                          </div>
                      {/*)}*/}
                  </div>


                  {/*<UniversalLineWithComponents*/}
                  {/*    basicStyle='line-with-components-without-borders-top-and-bottom-margin'*/}
                  {/*    leftSide={[*/}

                  {/*        // {*/}
                  {/*        //     component: customButton,*/}
                  {/*        //     props: {*/}
                  {/*        //         name: 'Aktywność użytkowników',*/}
                  {/*        //         baseClass: (activeChart === 'Aktywność użytkowników') ? 'custom-button-white-buttons-in-row-stats active' : 'custom-button-white-buttons-in-row-stats',*/}
                  {/*        //         hoverClass: 'hover-effect',*/}
                  {/*        //         onClick: () => {*/}
                  {/*        //             dispatch(toggleActiveChart('Aktywność użytkowników'))*/}
                  {/*        //         },*/}
                  {/*        //     },*/}
                  {/*        // },*/}
                  {/*        // {*/}
                  {/*        //     component: customButton,*/}
                  {/*        //     props: {*/}
                  {/*        //         name: 'Wyświetlenia po promocji',*/}
                  {/*        //         baseClass: (activeChart === 'Wyświetlenia po promocji') ? 'custom-button-white-buttons-in-row-stats active' : 'custom-button-white-buttons-in-row-stats',*/}
                  {/*        //         hoverClass: 'hover-effect',*/}
                  {/*        //         onClick: () => {*/}
                  {/*        //             dispatch(toggleActiveChart('Wyświetlenia po promocji'))*/}
                  {/*        //         },*/}
                  {/*        //     },*/}
                  {/*        // },*/}

                  {/*    ]}*/}
                  {/*    rightSide={[]}/>*/}



                  {/*--------------------------------------------------------------------*/}
                  <div className="chart-with-frame-big-3">
                      <UniversalLineWithComponents
                          basicStyle='line-with-components-without-borders-top-margin'
                          leftSide={[{
                              component: customText,
                              props: {
                                  icon: Chart,
                                  text: 'Wiek',
                                  baseClass: 'custom-text-bold',
                              },
                          }]}
                          rightSide={[]}/>

                      {/* Checkboxy do wyboru słupków */}

                      <div className="stats-bars-filters">

                          <label className="stats-bars-filters__item" style={{backgroundColor: '#2F5F6D'}}>
                              <input
                                  className="stats-bars-filters__checkbox"
                                  type="checkbox"
                                  checked={visibleBarsDemography.all}
                                  onChange={() => toggleBarDemography('all')}
                              />
                              {/*<div*/}
                              {/*    className="stats-pie-legend-dot"*/}
                              {/*    style={{backgroundColor: PIE_COLORS[index]}}*/}
                              {/*/>*/}
                              Wszyscy
                          </label>
                          <label className="stats-bars-filters__item" style={{backgroundColor: '#EE8F3B'}}>
                              <input
                                  className="stats-bars-filters__checkbox"
                                  type="checkbox"
                                  checked={visibleBarsDemography.male}
                                  onChange={() => toggleBarDemography('male')}
                              />
                              {/*<div*/}
                              {/*    className="stats-pie-legend-dot"*/}
                              {/*    style={{backgroundColor: PIE_COLORS[index]}}*/}
                              {/*/>*/}
                              Mężczyźni
                          </label>

                          <label className="stats-bars-filters__item" style={{backgroundColor: '#00868B'}}>
                              <input
                                  className="stats-bars-filters__checkbox"
                                  type="checkbox"
                                  checked={visibleBarsDemography.female}
                                  onChange={() => toggleBarDemography('female')}
                              />
                              Kobiety
                          </label>

                          <label className="stats-bars-filters__item" style={{backgroundColor: '#0aa2d5'}}>
                              <input
                                  className="stats-bars-filters__checkbox"
                                  type="checkbox"
                                  checked={visibleBarsDemography.other}
                                  onChange={() => toggleBarDemography('other')}
                              />
                              Inni
                          </label>
                      </div>

                      <ResponsiveContainer>
                          <BarChart
                              data={dataXXX}
                              margin={{
                                  top: 20,
                                  right: 30,
                                  left: 0,
                                  bottom: 145,
                              }}>
                              <CartesianGrid strokeDasharray="3 0" horizontal={true} vertical={false}/>
                              <XAxis dataKey="key"/>
                              <YAxis scale="linear"
                                     tickFormatter={(value) => Math.round(value / 10) * 10}
                                     interval={0}
                                     allowDecimals={false}/>
                              <Tooltip cursor={{
                                  fill: '#3F0A0A0A',
                                  radius: [10, 10, 0, 0]
                              }}
                              />
                              {/*<Legend />*/}
                              {visibleBarsDemography.all && (
                                  <Bar dataKey="all" fill="#2F5F6D" name="Wszyscy" barSize={20}
                                       radius={[8, 8, 0, 0]}/>
                              )}
                              {visibleBarsDemography.male && (
                                  <Bar dataKey="male" fill="#EE8F3B" name="Mężczyźni" barSize={20}
                                       radius={[8, 8, 0, 0]}/>
                              )}
                              {visibleBarsDemography.female && (
                                  <Bar dataKey="female" fill="#00868B" name="Kobiety" barSize={20}
                                       radius={[8, 8, 0, 0]}/>
                              )}
                              {visibleBarsDemography.other && (
                                  <Bar dataKey="other" fill="#0aa2d5" name="Inni" barSize={20}
                                       radius={[8, 8, 0, 0]}/>
                              )}
                          </BarChart>
                      </ResponsiveContainer>
                  </div>
                  {/*--------------------------------------------------------------------*/}



                  {/*{activeChart === 'Aktywność użytkowników' && */}
                      <div className="chart-with-frame-big">
                          <UniversalLineWithComponents
                              basicStyle='line-with-components-without-borders-top-margin'
                              leftSide={[{
                                  component: customText,
                                  props: {
                                      icon: Chart,
                                      text: 'Aktywność użytkowników',
                                      baseClass: 'custom-text-bold',
                                  },
                              }]}
                              rightSide={[{
                                  component: () => (
                                      <div className="chart-nav-buttons">
                                          <button
                                              onClick={handleBarPrev7}
                                              // disabled={barStartIndex === 0}
                                              className="nav-arrow"
                                          >❮❮</button>
                                          <button
                                              onClick={handleBarPrev}
                                              // disabled={barStartIndex === 0}
                                              className="nav-arrow"
                                          >❮</button>
                                          <button
                                              onClick={handleBarNext}
                                              disabled={new Date(endDate).setHours(0,0,0,0) >= new Date()}
                                              className="nav-arrow"
                                          >❯</button>
                                          <button
                                              onClick={handleBarNext7}
                                              disabled={new Date(endDate).getTime() + (6 * 24 * 60 * 60 * 1000) > new Date()}
                                              className="nav-arrow"
                                          >❯❯</button>
                                      </div>
                                  )
                            }]}/>

                          {/*/!* Checkboxy do wyboru słupków *!/*/}
                          {/*<div className="stats-bars-filters">*/}
                          {/*    <label className="stats-bars-filters__item" style={{backgroundColor: 'rgba(128,128,128,0.73)'}}>*/}
                          {/*        <input*/}
                          {/*            className="stats-bars-filters__checkbox"*/}
                          {/*            type="checkbox"*/}
                          {/*            checked={visibleDataSource.All}*/}
                          {/*            onChange={() => selectDataSource('All')}*/}
                          {/*        />*/}
                          {/*        Wszyscy*/}
                          {/*    </label>*/}

                          {/*    <label className="stats-bars-filters__item" style={{backgroundColor: 'rgba(128,128,128,0.73)'}}>*/}
                          {/*        <input*/}
                          {/*            className="stats-bars-filters__checkbox"*/}
                          {/*            type="checkbox"*/}
                          {/*            checked={visibleDataSource.Female}*/}
                          {/*            onChange={() => selectDataSource('Female')}*/}
                          {/*        />*/}
                          {/*        Kobiety*/}
                          {/*    </label>*/}

                          {/*    <label className="stats-bars-filters__item" style={{backgroundColor: 'rgba(128,128,128,0.73)'}}>*/}
                          {/*        <input*/}
                          {/*            className="stats-bars-filters__checkbox"*/}
                          {/*            type="checkbox"*/}
                          {/*            checked={visibleDataSource.Male}*/}
                          {/*            onChange={() => selectDataSource('Male')}*/}
                          {/*        />*/}
                          {/*        Mężczyźni*/}
                          {/*    </label>*/}

                          {/*    <label className="stats-bars-filters__item" style={{backgroundColor: 'rgba(128,128,128,0.73)'}}>*/}
                          {/*        <input*/}
                          {/*            className="stats-bars-filters__checkbox"*/}
                          {/*            type="checkbox"*/}
                          {/*            checked={visibleDataSource.Other}*/}
                          {/*            onChange={() => selectDataSource('Other')}*/}
                          {/*        />*/}
                          {/*        Inni*/}
                          {/*    </label>*/}
                          {/*</div>*/}

                          <div className="stats-bars-filters">
                              <label className="stats-bars-filters__item" style={{backgroundColor: '#2F5F6D'}}>
                                  <input
                                      className="stats-bars-filters__checkbox"
                                      type="checkbox"
                                      checked={visibleBars.Przeglad}
                                      onChange={() => toggleBar('Przeglad')}
                                  />
                                  {/*<div*/}
                                  {/*    className="stats-pie-legend-dot"*/}
                                  {/*    style={{backgroundColor: PIE_COLORS[index]}}*/}
                                  {/*/>*/}
                                  Przeglądanie wydarzenia
                              </label>

                              <label className="stats-bars-filters__item" style={{backgroundColor: '#EE8F3B'}}>
                                  <input
                                      className="stats-bars-filters__checkbox"
                                      type="checkbox"
                                      checked={visibleBars.Paczka}
                                      onChange={() => toggleBar('Paczka')}
                                  />
                                  Utworzenie paczki
                              </label>

                              <label className="stats-bars-filters__item" style={{backgroundColor: '#00868B'}}>
                                  <input
                                      className="stats-bars-filters__checkbox"
                                      type="checkbox"
                                      checked={visibleBars.Ulubione}
                                      onChange={() => toggleBar('Ulubione')}
                                  />
                                  Dodanie do ulubionych
                              </label>
                          </div>


                          <ResponsiveContainer>
                              <BarChart
                                  data={visibleData1}
                                  margin={{
                                      top: 20,
                                      right: 30,
                                      left: 0,
                                      bottom: 155,
                                  }}>
                                  <CartesianGrid strokeDasharray="3 0" horizontal={true} vertical={false}/>
                                  <XAxis dataKey="dzien"/>
                                  <YAxis scale="linear"
                                         tickFormatter={(value) => Math.round(value / 10) * 10}
                                         interval={0}
                                         allowDecimals={false}/>
                                  <Tooltip cursor={{
                                      fill: '#3F0A0A0A',
                                      radius: [10, 10, 0, 0]
                                  }}
                                  />
                                  {/*<Legend />*/}
                                  {visibleBars.Przeglad && (
                                      <Bar dataKey="Przeglad" fill="#2F5F6D" name="Przeglądanie wydarzenia" barSize={20}
                                           radius={[8, 8, 0, 0]}/>
                                  )}
                                  {visibleBars.Paczka && (
                                      <Bar dataKey="Paczka" fill="#EE8F3B" name="Utworzenie paczki" barSize={20}
                                           radius={[8, 8, 0, 0]}/>
                                  )}
                                  {visibleBars.Ulubione && (
                                      <Bar dataKey="Ulubione" fill="#00868B" name="Dodanie do ulubionych" barSize={20}
                                           radius={[8, 8, 0, 0]}/>
                                  )}
                              </BarChart>
                          </ResponsiveContainer>
                      </div>
                  {/*}*/}

              {/*    /!*{activeChart === 'Wyświetlenia po promocji' && *!/*/}
              {/*        <div className="chart-with-frame-big-2 stats-chart-locked">*/}
              {/*            <div className="stats-chart-lock-overlay" aria-hidden="true">*/}
              {/*                <Lock className="stats-chart-lock-icon" />*/}
              {/*            </div>*/}
              {/*            <div className="stats-chart-content">*/}
              {/*                <UniversalLineWithComponents*/}
              {/*                    basicStyle='line-with-components-without-borders-top-margin'*/}
              {/*                    leftSide={[{*/}
              {/*                        component: customText,*/}
              {/*                        props: {*/}
              {/*                            icon: Chart,*/}
              {/*                            text: 'Wyświetlenia po promocji',*/}
              {/*                            baseClass: 'custom-text-bold',*/}
              {/*                        },*/}
              {/*                    }]}*/}
              {/*                    rightSide={[]}*/}
              {/*                />*/}
              {/*                <ResponsiveContainer width="100%" height={400}>*/}
              {/*                    <LineChart data={data2}*/}
              {/*                               margin={{*/}
              {/*                                   top: 35,*/}
              {/*                                   right: 50,*/}
              {/*                                   left: 10,*/}
              {/*                                   bottom: 0,*/}
              {/*                               }}>*/}
              {/*                        <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB"/>*/}
              {/*                        <XAxis*/}
              {/*                            dataKey="dzien"*/}
              {/*                            stroke="#6B7280"*/}
              {/*                        />*/}
              {/*                        <YAxis*/}
              {/*                            stroke="#6B7280"*/}
              {/*                        />*/}
              {/*                        <Tooltip*/}
              {/*                            cursor={{fill: '#0AE6EB20'}}*/}
              {/*                            contentStyle={{*/}
              {/*                                backgroundColor: '#ffffff',*/}
              {/*                                border: '1px solid #E5E7EB',*/}
              {/*                                borderRadius: '8px'*/}
              {/*                            }}*/}
              {/*                        />*/}
              {/*                        <Legend*/}
              {/*                            wrapperStyle={{*/}
              {/*                                color: '#333333',*/}
              {/*                                fontSize: '14px'*/}
              {/*                            }}*/}
              {/*                        />*/}
              {/*                        <ReferenceLine*/}
              {/*                            x="4-07"*/}
              {/*                            stroke="grey"*/}
              {/*                            strokeWidth={2}*/}
              {/*                            strokeDasharray="10 0"*/}
              {/*                            label={{*/}
              {/*                                value: "Start promocji",*/}
              {/*                                position: 'insideBottomLeft',*/}
              {/*                            }}*/}
              {/*                        />*/}
              {/*                        <Line*/}
              {/*                            type="monotone"*/}
              {/*                            dataKey="Przeglad"*/}
              {/*                            stroke="#00868B"*/}
              {/*                            strokeWidth={2}*/}
              {/*                            name="Liczba wyświetleń"*/}
              {/*                            dot={{fill: '#00868B', r: 4}}*/}
              {/*                            activeDot={{r: 6}}*/}
              {/*                        />*/}
              {/*                    </LineChart>*/}
              {/*                </ResponsiveContainer>*/}
              {/*            </div>*/}
              {/*        </div>*/}
              {/*/!*}*!/*/}


                  {/**********************************/}
                  {/*    zakładka rankingi początek  */}


              </div>}

              {activeTab === 'Rankingi' && (
                  <div className="stats-main">
                      <div className={"line-right-aligned"}>
                          <button
                              type="button"
                              className={`stats-top-toggle-btn ${activeTopRanking === 'interest' ? 'is-active' : ''}`}
                              onClick={() => setActiveTopRanking('interest')}
                          >
                              wg. popularności
                          </button>
                          <button
                              type="button"
                              className={`stats-top-toggle-btn ${activeTopRanking === 'packages' ? 'is-active' : ''}`}
                              onClick={() => setActiveTopRanking('packages')}
                          >
                              wg. dołączeń
                          </button>
                          <div className="filling-div"></div>

                          <CustomDropdown
                              placeholder="Wybierz opcję..."
                              options={dropdown1Options.map((opt, index) => ({
                                  value: opt.id.toString(),
                                  label: opt.name.toUpperCase()
                              }))}
                              value={dropdown1Value}
                              onChange={(e) => setDropdown1Value(e.target.value)}
                              hoverClass="hover-active"
                              activeClass="is-active"
                          />
                          <CustomDropdown
                              placeholder="Wybierz opcję..."
                              options={[
                                  { value: 'LAST_7_DAYS', label: 'Ostatnie 7 dni' },
                                  { value: 'ALL_TIME', label: 'Całość' },
                              ]}
                              value={dropdown2Value}
                              onChange={(e) => setDropdown2Value(e.target.value)}
                              hoverClass="hover-active"
                              activeClass="is-active"
                          />
                      </div>
                      <ColumnLayout className="stats-rankingsLayout" gap="lg">
                          {activeTopRanking === 'interest' && (
                              <Column
                                  header={
                                      <h2 className="stats-rankingTitle">
                                          <span className="stats-rankingTitle__top">Top {dropdown1Value === '0' ? 10 : 5}</span> wydarzeń według polubień
                                          <InfoIcon onClick={() => setShowRank1Modal(true)} />
                                      </h2>
                                  }

                                  className = "stats-rankingColumn"
                              >
                                  {loading ? (
                                      <p>Ładowanie...</p>
                                  ) : (
                                      topEventsByInterest.length > 0 ?
                                      topEventsByInterest.map((event, index) => (
                                          <div
                                              key={event.id || index}
                                              className="stats-rankingTileWrapper"
                                              onClick={() => openRankEventModal(event)}
                                          >
                                              {/*//todo tutaj edytować rodzaj kafelka pełny/niepełny*/}
                                              <CustomTile
                                                  imageUrl={`/api/events-images/${event.image_hash_code}`}
                                                  // textLines={
                                                  //     dropdown1Value === '0'
                                                  //         ? [event.name]
                                                  //         : [event.name, event.place + ', ' + event.city, event.date]
                                                  // }
                                                  textLines={
                                                      [event.name,
                                                       event.place + ', ' + event.city,
                                                       formatEventDate(event.startDate),
                                                       formatEventTime(event.startDate)]
                                                  }
                                                  backgroundColor={index < 3 ? "#EFEBE4" : "#F4F4F4"}
                                                  showNumber={true}
                                                  number={event.rank.toString()}
                                                  numberColor={index < 3 ? "#EE8F3B" : "#7D959F"}
                                                  useAuth={true}
                                                  tileClassName='top-custom-tile'
                                              />
                                          </div>
                                      )) : <div className="stats-rankingTileWrapper">Brak danych</div>
                                  )}
                              </Column>
                          )}

                          {activeTopRanking === 'packages' && (
                              <Column
                                  header={
                                      <h2 className="stats-rankingTitle">
                                          <span className="stats-rankingTitle__top">Top {dropdown1Value === '0' ? 10 : 5}</span> wydarzeń według dołączeń
                                          <InfoIcon onClick={() => setShowRank2Modal(true)} />
                                      </h2>
                                  }
                                  className = "stats-rankingColumn"
                              >
                                  {loading ? (
                                      <p>Ładowanie...</p>
                                  ) : (
                                      topEventsByPackages.length > 0 ?
                                      topEventsByPackages.map((event, index) => (
                                          <div
                                              key={event.id || index}
                                              className="stats-rankingTileWrapper"
                                              onClick={() => openRankEventModal(event)}
                                          >
                                              {/*//todo tutaj edytować rodzaj kafelka pełny/niepełny*/}
                                              <CustomTile
                                                  imageUrl={`/api/events-images/${event.image_hash_code}`}
                                                  // textLines={
                                                  //     dropdown1Value === '0'
                                                  //         ? [event.name]
                                                  //         : [event.name, event.place + ', ' + event.city, event.startDate]
                                                  // }
                                                  textLines={[
                                                      event.name,
                                                      event.place + ', ' + event.city,
                                                      formatEventDate(event.startDate),
                                                      formatEventTime(event.startDate)]}
                                              backgroundColor={index < 3 ? "#EFEBE4" : "#F4F4F4"}
                                                  showNumber={true}
                                                  number={event.rank.toString()}
                                                  numberColor={index < 3 ? "#EE8F3B" : "#7D959F"}
                                                  useAuth={true}
                                                  tileClassName='top-custom-tile'
                                              />
                                          </div>
                                      )) : <div className="stats-rankingTileWrapper">Brak danych</div>
                                  )}
                              </Column>
                          )}
                      </ColumnLayout>
                  </div>
              )}
          </div>
        </div>
      </Content>
        <InfoModal
            isOpen={showViewsModal}
            onClose={() => setShowViewsModal(false)}
            title="Wyświetlenia"
            description="Wykres pokazuje łączną liczbę wyświetleń Twojego wydarzenia oraz profil użytkowników, którzy je wyświetlili."
        />
        <InfoModal
            isOpen={showUsersModal}
            onClose={() => setShowUsersModal(false)}
            title="Użytkownicy"
            description="Wykres pokazuje łączną liczbę oraz profil użytkowników, którzy utworzyli lub dołączyli do paczek związanych z Twoim wydarzeniem."
        />
        <InfoModal
            isOpen={showUsers2Modal}
            onClose={() => setShowUsers2Modal(false)}
            title="Użytkownicy"
            description="
            Nowy użytkownik – osoba, która po raz pierwszy utworzyła lub dołączyła do paczki
            pod którymkolwiek z Twoich wydarzeń.
            Powracający użytkownik – osoba, która już wcześniej brała udział w paczkach pod
            Twoimi wydarzeniami.
            "
        />

        <InfoModal
            isOpen={showRank1Modal}
            onClose={() => setShowRank1Modal(false)}
            title="Wydarzenia według dołączeń"
            description="Liczba użytkowników, którzy polubili wydarzenie."
        />

        <InfoModal
            isOpen={showRank2Modal}
            onClose={() => setShowRank2Modal(false)}
            title="Wydarzenia według polubień"
            description="Utworzenie lub dołączenie do paczki pod wydarzeniem."
        />
        {isRankEventModalOpen && rankEventModalData && (
            <div className="stats-rank-modal-overlay" onClick={closeRankEventModal}>
                <div className="stats-rank-modal" onClick={(e) => e.stopPropagation()}>
                    <button className="stats-rank-modal-close" type="button" onClick={closeRankEventModal}>
                        x
                    </button>
                    <div className="stats-rank-modal-title">{rankEventModalData.name}</div>
                    <div className="stats-rank-modal-date">
                        {formatEventDate(rankEventModalData.startDate || rankEventModalData.date)}
                    </div>
                    <div className="stats-rank-modal-tile">
                        <CustomTile
                            imageUrl={`/api/events-images/${rankEventModalData.image_hash_code}`}
                            textLines={[
                                rankEventModalData.name,
                                `${rankEventModalData.place || ''}${rankEventModalData.city ? ', ' + rankEventModalData.city : ''}`,
                                formatEventDate(rankEventModalData.startDate || rankEventModalData.date),
                                formatEventTime(rankEventModalData.startDate)
                            ]}
                            backgroundColor="#F4F4F4"
                            showNumber={false}
                            useAuth={true}
                            tiny={false}
                            tileClassName="stats-rank-modal-custom-tile"
                            imageContainerClassName="custom-image-container-big"
                            imageClassName="custom-image-rounded"
                        />
                    </div>
                    <div className="stats-rank-modal-section">Opis</div>
                    <div className="stats-rank-modal-desc">
                        {rankEventModalData.description || 'Brak opisu wydarzenia.'}
                    </div>
                </div>
            </div>
        )}
    </div>
  );
}

export default Stats;
